export const LVE_DASHBOARD_PATH = '/lve-dashboard';

export const LVE_MEETING_PATH = `${LVE_DASHBOARD_PATH}/meeting/:meetingId`;

export const meetingPath = (meetingId: number): string => `${LVE_DASHBOARD_PATH}/meeting/${meetingId}`;
